import styleInject from '../../../dependencies/style-inject/dist/style-inject.es.js';

var css_248z = ".rf-notifications__list[data-v-6e52f9c7] {\n  display: flex;\n  flex-direction: column-reverse;\n  position: fixed;\n  bottom: 60px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 1001;\n}";
styleInject(css_248z);

export { css_248z as default };
